"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = _interopRequireDefault(require("./Table.style"));
var _excluded = ["children", "borderless", "striped", "align", "hoverable"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Table = function Table(_ref) {
  var children = _ref.children,
    borderless = _ref.borderless,
    striped = _ref.striped,
    align = _ref.align,
    hoverable = _ref.hoverable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Table["default"], _extends({
    borderless: borderless,
    striped: striped,
    align: align,
    hoverable: hoverable
  }, otherProps), children);
};
Table.defaultProps = {
  borderless: false,
  striped: true,
  align: 'left',
  hoverable: false
};
Table.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /** Flag to indicate if table should have borders */
  borderless: _propTypes["default"].bool,
  /** The content of the table, normally `TableHeader` and `TableBody`. */
  children: _propTypes["default"].node.isRequired,
  /** Flag to indicate if table rows should have a differnt hover color */
  hoverable: _propTypes["default"].bool,
  /** Flag to indicate if table rows should alternate colors */
  striped: _propTypes["default"].bool
};
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table",
  "props": {
    "borderless": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if table should have borders",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "striped": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Flag to indicate if table rows should alternate colors",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "The alignment of the table text",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }]
      },
      "required": false
    },
    "hoverable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if table rows should have a differnt hover color",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "description": "The content of the table, normally `TableHeader` and `TableBody`.",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = Table;
exports["default"] = _default;